module.exports = __webpack_public_path__ + "assets/language-squares/ru-44ef08b7d416af2edb5af74c8a65e062.jpg";